import { PageHeader } from "../../components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import Channels from "./marketing/Channels";
import Campaigns from "./marketing/Campaigns";
import Calls from "./marketing/Calls";
import Search from "./marketing/Search";
import Pages from "./marketing/Pages";
import Audit from "./marketing/Audit";
import Reputation from "./marketing/Reputation";
import Connections from "./marketing/Connections";

const TABS = [["ch", "Kanal Panosu", Channels], ["camp", "Kampanyalar & Harcama", Campaigns], ["calls", "Aramalar", Calls], ["gsc", "Search Console", Search], ["pages", "Sayfalar & İlçe Üretici", Pages],
  ["audit", "Site Denetimi", Audit], ["rep", "Yorumlar & Profil", Reputation], ["conn", "Bağlantılar & Ayarlar", Connections]];

export default function Marketing() {
  return (
    <div className="space-y-6" data-testid="marketing-page">
      <PageHeader eyebrow="Pazarlama" title="Pazarlama Merkezi" subtitle="Reklam ve organik görünürlüğü iş ve kâr düzeyinde ölçün: kampanya kârı, aramalar, Search Console, ilçe sayfaları, site denetimi, yorumlar." />
      <Tabs defaultValue="ch" urlTab>
        <TabsList className="flex-wrap h-auto">{TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`mtab-${k}`}>{l}</TabsTrigger>)}</TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k} className="mt-4"><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
